
import { defineComponent } from 'vue';
import customModelMixin from '../mixins/custom-model';

export default defineComponent({
  name: 'BaseFormCheckbox',
  mixins: [customModelMixin],
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasContent(): boolean {
      return !!this.$slots.default;
    }
  }
});
